// extracted by mini-css-extract-plugin
module.exports = {"header":"TeachingMaterialHeader_header__2f-RT","portfolio":"TeachingMaterialHeader_portfolio__1rPS3"};